import { logout, isLogin } from './userInfo.service'

export { logout, isLogin }
